  <div class="subscribers-container">
    <dx-drop-down-box
      [(value)]="subscriptionIds"
      valueExpr="subscriptionId"
      displayExpr="title"
      [label]="'COMMON.FIELDS.SUBSCRIBERS' | translate"
      [dataSource]="subscribers"
      [readOnly]="isViewMode"
      labelMode="floating"
      stylingMode="outlined"
      [showClearButton]="true"
      (onValueChanged)="onSubscriptionsValueChanged($event)"
    >
      <div *dxTemplate="let data of 'content'">
        <dx-tree-view
          #subscriptionsTree
          [searchEnabled]="true"
          [dataSource]="subscribers"
          dataStructure="plain"
          keyExpr="subscriptionId"
          displayExpr="title"
          selectionMode="multiple"
          showCheckBoxesMode="normal"
          [selectNodesRecursive]="false"
          [selectByClick]="true"
          showCheckBoxesMode="selectAll"
          (onSelectAllValueChanged)="onSubscriptionsSelectAllChanged($event)"
          (onItemSelectionChanged)="onSubscriptionSelected($event)"
        >
          <div *dxTemplate="let item of 'item'">
            <div class="subscriber-item">
              <div class="subscriber-logo">
                <img
                  *ngIf="item.company"
                  [src]="item.company.fileUrl"
                />
              </div>

              <span>{{ item.title }}</span>
            </div>
          </div>
        </dx-tree-view>
      </div>
    </dx-drop-down-box>
  </div>
  
  @if (subscriptionIds.length === 0) {
    <div class="info-container no-filters-container">
      <i class="dx-icon dx-svg-icon" [innerHTML]="getWarningIcon()"></i>
      <span
        [innerHTML]="
          'TARGET-GROUP.PUBLISH-TRAINING.NO-SUBSCRIBERS-WARNING' | translate
        "
      ></span>
    </div>
  } @else if (areAllSubscribersSelected) {
    <div class="info-container employee-target-container">
      <i class="dx-icon dx-svg-icon" [innerHTML]="getCheckIcon()"></i>
      <span
        [innerHTML]="
          'TARGET-GROUP.PUBLISH-TRAINING.ALL-SUBSCRIBERS-SELECTED' | translate
        "
      ></span>
    </div>
  } @else {
    <div class="info-container employee-target-container">
      <i class="dx-icon dx-svg-icon" [innerHTML]="getCheckIcon()"></i>
      <span
        [innerHTML]="getSubscribersVisibleInText()"
      ></span>
    </div>
  }